export default "__VITE_ASSET__CyONriLo__"